import { v4 as uuidv4 } from 'uuid';

export const createGuid = () => uuidv4().toString();
